<template>
  <div class="charge">
    <div class="toolBar">
      <p>
        <label>患者姓名：</label>
        <Input v-model="name" placeholder="患者姓名" />
      </p>
      <p>
        <label>医生：</label>
        <Input v-model="doctor" placeholder="医生"/>
      </p>
      <p>
        <label>自定义日期：</label>
        <DatePicker type="date" :options="options3" format="yyyy-MM-dd" @on-change="startTime" placeholder="开始日期" v-model="startDate"></DatePicker>
         —
        <DatePicker type="date" :options="options3" format="yyyy-MM-dd" @on-change="endTime" placeholder="结束日期" v-model="endDate"></DatePicker>
      </p>
      <p>
        <Button type="primary" @click="search">查询</Button>
      </p>
    </div>
    <div class="mainBox">
       <Table :height="tableHeight" ref="table" :columns="columns1" :data="data1"></Table>
       <div class="pageBox">
         <Page :total="total" :transfer='true' show-elevator show-sizer @on-change="changePage" @on-page-size-change="changePageSize" />
       </div>
    </div>
    <Modal 
        width="60%"
        :name="modelName"
        v-model="modal2"
        :title="modelTitle"
        :scrollable="true"
        @on-ok="confirm"
        @on-cancel="cancel">
        <div class="accountBox">
          <div class="basiInfo" v-show="isShow">
            <p>
              <span>患者：</span>
              <span class="keyName" v-if="patientName">{{patientName}}</span>
            </p>
            <p>
              <span>性别：</span>
              <span v-if="sexName">{{sexName}}</span>
            </p>
            <p>
              <span>年龄：</span>
              <span v-if="age||ageUnit">{{age}}{{ageUnit}}</span>
            </p>
            <p>
              <span>医生：</span>
              <span v-if="doctorName">{{doctorName}}</span>
            </p>
            <p>
              <span>就诊日期：</span>
              <span v-if="diagnosisTime">{{diagnosisTime}}</span>
            </p>
            <p>
              <span>诊断：</span>
              <span v-if="diagnosis">{{diagnosis}}</span>
            </p>
          </div>
          <div class="basiInfo" v-show="isShow">
            <p>
              <span>收费时间：</span>
              <span v-if="chargeTime">{{chargeTime}}</span>
            </p>
            <p>
              <span>收费员：</span>
              <span v-if="collector">{{collector}}</span>
            </p>
            <p>
              <span>应收：</span>
              <span v-if="amount">{{amount}}</span>
            </p>
            <!-- <p>
              <span>优惠：</span>
              <span>{{doctorName}}</span>
            </p> -->
            <p>
              <span>实收：</span>
              <span v-if="actualAmount">{{actualAmount}}</span>
            </p>
            <p>
              <span>支付方式：</span>
              <span v-if="payTypeName">{{payTypeName}}</span>
            </p>
          </div>
          <div class="projectBox" v-if="projectItems">
            <p>检测项目</p>
            <ul>
              <li>
                <span>项目名称</span>
                <span>金额</span>
              </li>
              <li v-for="(pro,index) in projectItems" v-bind:key="index">
                <span>{{pro.projectName}}</span>
                <span>{{pro.price}}</span>
              </li>
            </ul>
          </div>
          <div class="projectBox">
            <p v-if="otherItems">其他收费</p>
            <ul v-if="otherItems">
              <li>
                <span>收费项目</span>
                <span>金额</span>
              </li>
              <li v-for="(other,index) in otherItems" v-bind:key="index">
                <span>{{other.itemsName}}</span>
                <span>{{other.price}}</span>
              </li>
            </ul>
            <div class="payBox" v-show="!isShow">
              <ul>
                <!-- <li>
                  <label>退款原因：</label>
                  <p>
                    <Input v-model="refundReason" type="textarea" :rows="4" placeholder="退款原因" />
                  </p>
                </li> -->
                <li>
                  <label>退款方式：</label>
                  <p>
                    <RadioGroup v-model="payType">
                      <Radio :label="ptype.value" v-for="(ptype,index) in payTypeList" v-bind:key="index">
                        <Icon :custom="ptype.icon"></Icon>
                        <span>{{ptype.label}}</span>
                      </Radio>
                    </RadioGroup>
                  </p>
                </li>
                <li>
                  <label>退款金额：</label>
                  <p>
                    <Input v-model="payPrice" style="width: 100px" />
                    <span>元</span>
                  </p>
                </li>
                <!-- <li>
                  <label>找零：</label>
                  <p>
                    <span>{{change}}</span>
                  </p>
                </li> -->
                <li>
                  <label>实收金额：</label>
                  <p>
                    ￥<span>{{actualAmount}}</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div slot="footer" v-show="!isShow">
            <Button type="text" size="large" @click="cancel">取消</Button>
            <Button type="primary" size="large" @click="confirm">退费</Button>
        </div>
    </Modal>
  </div>
</template>

<script>
import {getLodop} from '@/assets/js/LodopFuncs.js'
import {baseImg} from "@/config"
import {
  haveChargeList,haveChargeDetail,
  cancelWaitCharge,refund
} from "../../../api/charge";
import {samplingDetail} from "../../../api/clinic";
import { tips,replaceT,payType } from "../../../tools";
export default {
  name: 'HaveCharge',
  data () {
    return {
      tableHeight:632,
      //禁用今天之后的日期
      options3:{
        disabledDate (date) {
          return date && date.valueOf() > Date.now();
        }
      },
      isShow:true,//收费还是详情
      refundReason:'',
      actualAmount:240,
      chargeId:0,
      modelName:'',
      modal2:false,
      modelTitle:'',
      total:0,
      pageCurrent:1,
      pageSize: 10,
      name:'',//患者姓名/手机号
      doctor:'',//医生
      clinicTime:'',//就诊时间
      clinicTimeList:[],
      startDate:'',//开始日期
      endDate:'',//结束日期
      chargeCategory:'',//收费门类
      chargeCategorys:[],
      columns1:[
        {
          title: '患者',
          key: 'hospitalPatientName',
          align:'center'
        },
        {
          title: '电话',
          key: 'mobile',
          align:'center'
        },
        {   
          title: '性别',
          key: 'sex',
          align:'center',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: params.row.sex==1?'男':'女' 
              },
            })
          }
        },
        {
            title: '年龄',
            key: 'age',
            align:'center'
        },
        {
            title: '年龄单位',
            key: 'ageUnit',
            align:'center'
        },
        {
            title: '医生',
            key: 'doctorName',
            align:'center'
        },
        {
            title: '就诊日期',
            key: 'chargeTime',
            align:'center',
            render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: replaceT(params.row.chargeTime) 
              },
            })
          }
        },
        {
            title: '应收金额(元)',
            key: 'amount',
            align:'center'
        },
        {
            title: '实收金额(元)',
            key: 'actualAmount',
            align:'center'
        },
        {
          title: '操作',
          align:'center',
          key: 'methods',
          align: 'center',
          minWidth:180,
          render: (h, params) => {
            return h('div',{
              style: {
                  textAlign: 'center'
                }
              },
              [
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-shoufei3'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#2778E7',
                    color:'#2778E7'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      this.modal2 = true;
                      this.isShow = false;
                      this.modelName = 'toRefund';
                      this.modelTitle = '退费确认';
                      let id = params.row.id;
                      this.haveChargeDetail(id,params.row);
                    },
                  }
                }, '退费'),
                
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-shoufei3'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#2778E7',
                    color:'#2778E7'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      // this.modal3 = true;
                      this.modelName = 'printDetail';
                      this.modelTitle = '打印详情';
                      let id = params.row.id;
                      if(id>0){
                        this.haveChargeDetail(id,params.row);
                      }
                    },
                  }
                }, '打印'),
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-order'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#2778E7',
                    color:'#2778E7'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      let id = params.row.id;
                      this.isShow = true;
                      this.modal2 = true;
                      this.modelName = 'chargeDetail';
                      this.modelTitle = '已收费详情';
                      this.haveChargeDetail(id,params.row);
                    }
                  }
                }, '详情'),
            ]);
          }
        }
      ],
      data1:[],
      patientName:'',
      sexName:'',
      age:0,
      ageUnit:'',
      doctorName:'',
      diagnosisTime:'',
      diagnosis:'',
      projectItems:[],
      otherItems:[],
      payPrice:0,
      change:'0.00',//找零
      payType:1,
      payTypeList:[
        {
          label:'现金',
          value:1,
          icon:' iconfont icon-zhanghuyue'
        },
        {
          label:'医保',
          value:2,
          icon:' iconfont icon-yibao'
        },
        {
          label:'微信',
          value:3,
          icon:' iconfont icon-weixinzhifu'
        },
        {
          label:'支付宝',
          value:4,
          icon:' iconfont icon-zhifubao'
        },
        {
          label:'银联',
          value:5,
          icon:' iconfont icon-yinhangqia'
        },
        {
          label:'其他',
          value:6,
          icon:''
        }
      ],
      refundType:1,//退费方式
      chargeTime:'',
      collector:'',//收费员
      amount:0,
      payTypeName:''
    }
  },
  created(){
    let lett = this;
    document.onkeydown = function(e) {
    let key = window.event.keyCode;
    if (key == 13) {
      lett.search();
      }
    }
  },
  mounted(){
    window.addEventListener('resize', this.getTableHeight);
    this.getTableHeight();
    this.loadList();
  },
  methods:{
    getTableHeight(){
      // 设置表格高度 
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop-90; 
    },
    loadList(){
      this.search();
    },
    //搜索
    search(){
      let _this = this;
      let params = {
        current: _this.pageCurrent,
        endTimes: _this.endDate,
        name: _this.doctor,
        nameAndPhone: _this.name,
        size: _this.pageSize,
        starTimes: _this.startDate
      };
      haveChargeList(
        params
      ).then(res => {
        console.log(res)
        let data = res.records;
        _this.total = res.total;
        _this.data1 = data;
      });
    },
    // 收费详情
    haveChargeDetail(id,params){
      let _this = this;
      haveChargeDetail({
        id:id
      }).then(res =>{
        console.log(res);
        _this.chargeId = res.id;
        _this.actualAmount = res.amount;
        _this.amount = res.amount;
        _this.patientName = res.hospitalPatientName;
        _this.sexName = res.sex==1?'男':'女';
        _this.age = res.age;
        _this.ageUnit = res.ageUnit;
        _this.doctorName = res.doctorName;
        _this.chargeTime = replaceT(res.chargeTime);
         _this.diagnosisTime = replaceT(res.diagnosisTime);
        _this.diagnosis = res.diagnosis;
        _this.projectItems = res.hisProjectVos;
        _this.otherItems = res.hisOtherOrihechVos;
        _this.collector = res.cashierName;
        _this.payTypeName = payType(res.payType);

        if(this.modelName=='printDetail'){
          if(res.hisProjectIds){
            this.samplingDetail(res.hisProjectIds,res);
          }else{
            this.getPrint(res,[]);
          }
        }
      })
    },
    getPrint(data,sampItems){
      var LODOP=getLodop();
      this.createPrintPage(data,sampItems);
      // LODOP.PRINT_SETUP();
      // LODOP.PRINT_DESIGN();	
      LODOP.PREVIEW();
    },
    //调取打印
    createPrintPage(data,sampItems){
      console.log(sampItems);
      console.log(data);
      var LODOP=getLodop();
      // console.log(this.myInfo);
      console.log(sampItems);
      let forStr = '';
      if(sampItems){
        for(let i=0;i<sampItems.length;i++){
          forStr += `<tr><td><span></span></td>
          <td>${sampItems[i].proNameItem}</td>
            <td>${sampItems[i].samplingColor}</td>
            <td>${sampItems[i].specimenTypeName}(${sampItems[i].count}${sampItems[i].unitName})</td>
            <td>${sampItems[i].samplingNum}</td>
          </tr>`;
        }
        // console.log(forStr);
      }
      if(data.hisProjectVos){
        let proArr = [];
        for(let i=0;i<data.hisProjectVos.length;i++){
          proArr.push(data.hisProjectVos[i].projectName);
        }
        console.log(proArr);
        data.proName = proArr.join(',');
      }else{
        data.proName = '';
      }
      
      let myInfo = data;
      console.log(data);
      
      let footStr = `<div class="price" style="display: flex;justify-content: space-between;padding: 10px 10%;margin-top:10px;">
        <div style="display: flex;margin-right: 20px;">
          <p style="font-size: 14px;line-height: 30px;">样本性状：</p>
          <p style="font-size: 14px;line-height: 30px;">
            <span style="font-size:12px;"><i class="display:inline-block;width:10px;height:10px;border:1px solid #c9c9c9;"></i>正常</span>
            <span style="font-size:12px;"><i></i>脂浊</span>
            <span style="font-size:12px;"><i></i>轻度溶血</span>
            <span style="font-size:12px;"><i></i>量少</span>
            <span style="font-size:12px;"><i></i>其他</span>
          </p>
        </div>
        <p style="display: flex;">
          <span style="display: inline-block;line-height: 30px;font-size: 14px; ">采样时间：</span>
          <span class="text" style="min-width: 100px;height: 24px; display: inline-block;line-height: 30px;font-size: 14px; "></span>
        </p>
        </div>`;
      // console.log(footStr);
      let strHtml = `<style>table,td,th {border: 1px solid black;border-style: solid;border-collapse: collapse;text-align:center;}
        table{width:84%;}tr{min-height:30px;paddind:10px;}td{width:20%;}.price>div>p>span>i{display:inline-block;width:10px;height:10px;border: 1px solid #c9c9c9;}</style><table border="1"><tr><td>项目名称：</td>
        <td colspan="4">${myInfo.proName}</td></tr><tr><td>条码粘贴处</td><td>项目明细</td><td>采集容器</td><td>样本类型</td><td>总量</td>
        </tr>`+forStr+`</table><table>`;
        // <div style="height:50px;margin-top:20px;">${footStr}</div>
      // console.log(strHtml);
      LODOP.PRINT_INITA(17,43,800,600,"检验申请单");
      LODOP.ADD_PRINT_TEXT(54,369,143,30,"检验申请单");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
      LODOP.SET_PRINT_STYLEA(0,"Horient",2);
      LODOP.SET_PRINT_STYLEA(0,"Vorient",3);
      LODOP.ADD_PRINT_TEXT(90,0,800,20,"-----------------------------------------------------------------------------------------------------------------------");
      LODOP.SET_PRINT_STYLEA(0,"Horient",2);
      LODOP.ADD_PRINT_TEXT(120,0,50,24,"姓名:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXTA("name",120,50,70,24,myInfo.hospitalPatientName);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(120,120,50,24,"性别:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXTA("sex",120,165,30,24,myInfo.sex==1?'男':'女');
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(120,205,50,24,"年龄:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(120,305,50,24,"科室:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXTA("age",120,255,50,24,myInfo.age+myInfo.ageUnit);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXTA("department",120,355,70,24,myInfo.departmentName);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(120,425,50,24,"床号:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(120,476,50,24,"       ");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.SET_PRINT_STYLEA(0,"Underline",1);
      LODOP.ADD_PRINT_TEXT(120,540,70,24,"就诊号:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(120,605,95,24,"        ");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.SET_PRINT_STYLEA(0,"Underline",1);
      LODOP.ADD_PRINT_TEXT(160,0,89,24,"送检医生:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXTA("doctorName",160,89,60,24,myInfo.doctorName);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(160,150,90,24,"下单时间:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXTA("orderTime",160,239,170,24,replaceT(myInfo.diagnosisTime));
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(160,417,90,24,"临床诊断:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(160,505,193,24,myInfo.diagnosis);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.SET_PRINT_STYLEA(0,"Underline",1);

      LODOP.ADD_PRINT_TABLE(254,0,800,400,strHtml);
      LODOP.ADD_PRINT_IMAGE(35,-5,135,52,`<img src='${baseImg}appLogo.png'>`);
      LODOP.SET_PRINT_STYLEA(0,"Stretch",2);
      LODOP.ADD_PRINT_TEXT(204,0,90,24,"样本性状：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_RECT(206,91,10,10,0,1);
      LODOP.ADD_PRINT_TEXT(204,102,50,24,"正常");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(204,162,50,24,"脂浊");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_RECT(206,152,10,10,0,1);
      LODOP.ADD_PRINT_RECT(206,212,10,10,0,1);
      LODOP.ADD_PRINT_TEXT(204,223,80,24,"轻度溶血");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_RECT(206,305,10,10,0,1);
      LODOP.ADD_PRINT_TEXT(204,316,50,24,"量少");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(204,462,90,24,"采样时间：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(204,552,100,24,"        ");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.SET_PRINT_STYLEA(0,"Underline",1);

    },
    //通过projectId查询样本
    samplingDetail(ids,data){
      // console.log(data);
      samplingDetail({
        orderIds:ids
      }).then(res=>{
        // console.log(res);
        // this.myInfo.projectShowItems = res;
        let sampArr = []; 
        let sampItems = res;
        
        for(let i=0;i<sampItems.length;i++){
          console.log(sampItems[i].list);
          let subArr = []
          for(let j=0;j<sampItems[i].list.length;j++){
            subArr.push(sampItems[i].list[j].projectName);
          }
          // console.log(subArr.join(','));
          // console.log(sampItems);
          this.$forceUpdate();
          this.$set(sampItems[i],'proNameItem',subArr.join(','));
          // sampArr.push(subArr.join(','));
        }
        this.getPrint(data,sampItems);
      });
    },
    //退费
    refund(){
      let _this = this;
      let params = {
        id: _this.chargeId,
        refundType: _this.payType,
      };
      console.log(params)
      refund(
        params
      ).then(res => {  
        console.log(res);
        tips(this,res,'success');
        this.$router.push({path:'/haverefund'})
      })
    },
    //取消
    cancelCharge(id){
      let _this = this;
      cancelWaitCharge({
        id:id
      }).then(res => {
        console.log(res);
        tips(this,res,'success');
        _this.loadList();
      });
    },
    //改变页码
    changePage(current){
      this.pageCurrent = current;
      this.loadList();
    },
    //改变每页条数
    changePageSize(size){
      this.pageSize = size;
      this.loadList();
    },
    confirm(){
      this.refund();
    },
    cancel(){
      this.modal2 = false;
    },
    startTime(e){
      this.startDate = e;
      console.log(e)
    },
    endTime(e){
      this.endDate = e;
      console.log(e)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.charge{

}
.charge .toolBar{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap ;
  padding: 10px 0;
}
.charge .toolBar>p{
  padding: 5px 0;
  margin-right: 20px;
}
.charge .toolBar>p>label{
  display: inline-block;
}
.pageBox{
  text-align: center;
  padding: 5px 0;
}
.ivu-input-wrapper{
  width: 120px;
}
.ivu-select{
  width: 120px;
  /* width: 100%; */
}
.ivu-date-picker{
  width: 120px;
}

/* 详情弹框 */
.accountBox{
  width: 100%;
}
.accountBox /deep/ .ivu-modal{
  height: 600px;
  overflow: hidden;
}
.accountBox /deep/ .ivu-modal-content{
  height: 100%;
  overflow: hidden;
}
.ivu-modal-body{
  font-size: 14px;
  overflow: scroll;
  height: 300px;
}
.basiInfo{
  display: flex;
  flex-flow: wrap row;
  justify-content: flex-start;
  padding: 8px 10px 8px;
  border-bottom: 1px solid #c9c9c9;
}
.basiInfo>p{
  margin-right: 30px;
  line-height: 32px;
  min-width: 100px;
}
.basiInfo>p>span:nth-child(2){
  padding-right: 30px;
  border-right: 1px solid #c9c9c9;
}
.basiInfo .keyName{
  color: #2778e2;
}
.projectBox{
  width: 100%;
}
.projectBox>p{
  padding: 10px 0;
  color:#030303;
  font-size: 14px;
  margin-left: 10px;
}
.projectBox>ul{
  width: 100%;
  border: 1px solid #c9c9c9;
}
.projectBox>ul>li{
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c9c9c9;
}
.projectBox>ul>li:last-child{
  border: none;
}
.projectBox>ul>li>span{
  text-align: center;
  width: 50%;
}
.projectBox>ul>li:first-child{
  height: 39px;
  line-height: 39px;
  border-bottom: 1px solid #c9c9c9;
}
.projectBox>ul>li:first-child>span{
  color: #030303;
}
.payBox{
  width: 100%;
  margin-top: 15px;
}
.payBox>ul{
  width: 100%;
}
.payBox>ul>li{
  display: flex;
  justify-content: flex-start;
  height: 40px;
  line-height: 40px;
  margin-top: 15px;
}
.payBox>ul>li:last-child{
  justify-content: flex-end;
  margin-right: 20px;
}
.payBox>ul>li:first-child{
  height: auto;
}
.payBox>ul>li:first-child>p{
  width: 70%;
}
.payBox>ul>li:first-child>p>.ivu-input-wrapper{
  width: 100%;
}
.payBox>ul>li>label{
  width: 100px;
  text-align: right;
}
.payBox>ul>li:last-child>p>span{
  color: #ff4568;
  font-size: 20px;
}
.icon-zhanghuyue{
  color: #fd605f;
}
.icon-yibao{
  color: #06a0a2;
}
.icon-weixinzhifu{
  color: #00ab45;
}
.icon-zhifubao{
  color: #289bd6;
}
.icon-yinhangqia{
  color: #ff9d2d;
}
</style>



// WEBPACK FOOTER //
// src/views/charge/haveCharge/HaveCharge.vue